/* istanbul ignore file */
import ExpertiseDropdown from 'domain/people/employee/expertise/components/fields/ExpertiseDropdown';
import { DropDownFilterProps, DropDownFilter } from 'framework/list';

const EmployeeExpertiseFilter = (props: Omit<DropDownFilterProps, 'children'>) => {
  return (
    <DropDownFilter {...props}>
      <ExpertiseDropdown {...props} />
    </DropDownFilter>
  );
};

export default EmployeeExpertiseFilter;
